import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

const Header = () => {
    const location = useLocation();

    return (
        <header className="main-header">
            <div className="header-container">
                <Link to="/" className="header-logo">
                    <h3>Depth Live Wallpaper Pro</h3>
                </Link>

                <nav className="header-nav">
                    <Link 
                        to="/terms" 
                        className={location.pathname === "/terms" || location.pathname === "/" ? "active" : ""}
                    >
                        Terms
                    </Link>
                    <Link 
                        to="/privacy" 
                        className={location.pathname === "/privacy" ? "active" : ""}
                    >
                        Privacy
                    </Link>
                </nav>
            </div>
        </header>
    );
};

export default Header;